(() => {
  const panelSelector = [
    '.wr-mira-brand-card',
    '.wr-mira-contains',
    '.wr-mira-media-hero'
  ].join(',');

  const mount = () => {
    document.querySelectorAll('.wr-card-stack-panel, .wr-card-stack-after').forEach((section) => {
      section.classList.remove('wr-card-stack-panel', 'wr-card-stack-panel--later', 'wr-card-stack-panel--last', 'wr-card-stack-after');
      section.style.removeProperty('--wr-stack-top');
      section.style.removeProperty('--wr-stack-z');
    });

    const panels = [...document.querySelectorAll(`.template-index ${panelSelector}`)]
      .map((panel) => panel.closest('.shopify-section'))
      .filter((panel, index, all) => panel && all.indexOf(panel) === index);

    panels.forEach((panel, index) => {
      panel.classList.add('wr-auto-align-panel', 'wr-card-stack-panel');
      if (index > 0) panel.classList.add('wr-card-stack-panel--later');
      if (index === panels.length - 1) panel.classList.add('wr-card-stack-panel--last');
      panel.style.setProperty('--wr-stack-top', '0px');
      panel.style.setProperty('--wr-stack-z', String(index + 2));
    });

    let followingSection = panels.at(-1)?.nextElementSibling;
    while (followingSection) {
      followingSection.classList.add('wr-card-stack-after');
      followingSection = followingSection.nextElementSibling;
    }
  };

  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('shopify:section:reorder', mount);
  mount();
})();
